module.exports = __webpack_public_path__ + "static/img/4.9281a2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/zh/4.png
// module id = moLt
// module chunks = 0